<h3 style="margin-left: 32px;">
  <span class="branding">Reporte porcentaje retroalimentaciones
  </span>
</h3>

<div class="glm-container border-background--1" *ngIf="vm$ | async as vm; else loading">
  <div class="report-body">

    <div class="report-filters">

      <div class="report-filters__filter--x1">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Profesor</mat-label>
          <input matInput [value]="vm.prosearch" (input)="searchProfesor($event)" />
          <mat-icon color="warn" style="cursor: pointer;" matSuffix (click)="resetSearch()" matTooltip="Borrar">
            clear
          </mat-icon>
        </mat-form-field>
      </div>

      <div class="report-filters__filter--x1">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Materia</mat-label>
          <input matInput [value]="vm.matsearch" (input)="searchMateria($event)" />
          <mat-icon color="warn" style="cursor: pointer;" matSuffix (click)="resetSearch()" matTooltip="Borrar">
            clear
          </mat-icon>
        </mat-form-field>
      </div>

    </div>

    <div class="table-container">
      <div class="loading-shade" *ngIf="vm.loading">
        <mat-progress-bar mode="indeterminate" *ngIf="vm.loading"></mat-progress-bar>
      </div>
      <mat-table *ngIf="vm.evidencias?.length > 0" [dataSource]="vm.evidencias" matSort class="full-width mat-elevation-z2">

        <ng-container matColumnDef="profesor">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="flex-row-select">Profesor</mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-row-select">{{element.profesorName}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="evento">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="flex-row-select">Evento</mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-row-select">{{element.eventoName}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="fecha">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="flex-row-select">Fecha</mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-row-select">{{element.fechaEvidencia}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="materia">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="flex-row-select">Materia</mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-row-select">{{element.materia}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="curso">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="flex-row-select">Curso</mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-row-select">{{element.curso}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="porcentaje">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="flex-row-select">porcentaje</mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-row-select">{{element.porcentaje}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="link">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="flex-row-select">Ir al evento</mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-row-select">
            <button
            class="button"
            mat-stroked-button
            color="primary"
            [routerLink]="['/estudio/unidad',element.unidadId,'retroalimentacion','evento',element.eventoUnidadId]"
            >
            Ir al evento
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
        </mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

        <mat-row *matNoDataRow>
          <mat-cell class="no-records">Sin registros</mat-cell>
        </mat-row>

      </mat-table>

      <mat-paginator [length]="vm.length" [pageSize]="vm.pageSize" [pageSizeOptions]="vm.pageSizeOptions"
        [pageIndex]="vm.pageIndex" (page)="setPage($event)">
      </mat-paginator>

    </div>
  </div>
</div>
<ng-template #loading>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>
